import { render, staticRenderFns } from "./tobeprocessed-order.vue?vue&type=template&id=7d46b634&"
import script from "./tobeprocessed-order.vue?vue&type=script&lang=js&"
export * from "./tobeprocessed-order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports